import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { UiFactory } from '../../core/ui/ui-factory';
import { PgLinearLoaderComponent } from '../pg-linear-loader.component';
import { LinearLoaderModel } from './linear-loader-model';
import { BehaviorService } from '../../core/behavior/behavior.service';

@Component({
  selector: 'pg-linear-loader-factory, grit-linear-loader-factory',
  templateUrl: './pg-linear-loader-factory.component.html',
  styleUrls: ['./pg-linear-loader-factory.component.scss'],
})
export class PgLinearLoaderFactoryComponent extends UiFactory {
  @Input('model')
  model: any;

  @ViewChild(PgLinearLoaderComponent, { static: true })
  linearLoader: PgLinearLoaderComponent;

  get linearLoaderModel(): LinearLoaderModel {
    return this.model;
  }

  get hostEl(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  constructor(
    public elementRef: ElementRef,
    public behaviorService: BehaviorService
  ) {
    super(behaviorService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
